import { BankGatewayTypeState } from "../../enums/index";
function getBankGatewayStateClass(type) {
  let result = "";
  switch (type) {
    case BankGatewayTypeState.Unknown():
      result = "suspend";
      break;
    case BankGatewayTypeState.Visited():
      result = "enabled";
      break;
    case BankGatewayTypeState.Succeeded():
      result = "enabled";
      break;
    case BankGatewayTypeState.Failed():
      result = "disabled";
      break;
    case BankGatewayTypeState.Canceled():
      result = "disabled";
      break;
    case BankGatewayTypeState.Reversed():
      result = "suspend";
      break;
    default:
      result = "";
      break;
  }
  return result;
}
export default getBankGatewayStateClass;
